import axios from 'axios';
import { getAPIDomain } from '../constants';

export type Metric = {
  metricName: string;
  navigationType: string;
  metricRating: string;
  metricValue: number;
  pageType: string;
  env: 'PROD' | 'STAGE';
};

export const postWebVitals = async (metrics: Metric): Promise<null> => {
  try {
    axios
      .post(`${getAPIDomain()}metric/web-vitals`, {
        ...metrics,
        navigationType: metrics?.navigationType ?? ''
      })
      .then(() => {
        return null;
      })
      .catch(() => {
        return null;
      });
  } catch (error) {
    return null;
  }
};
